import React from 'react';
import Developers from './Developers';
import FAQ from './FAQ';

class Footer extends React.Component {
  render() {
    return (
      <div class="footer-background-custom py-4">
        <div class="container">
          <div>
            <h3>
              How can we help?
            </h3>
            <p>
              Have some coronavirus symptoms? Worry about whether it is simply a cold, or COVID-19? Many people may have this kind of struggle during the pandemic, which puts a lot of pressure on people worldwide. Using machine learning algorithms, COVID-R is a simple tool that estimates the possibility of contracting COVID-19 based on a few survey questions, without the need of medical tests. The use of COVID-R is simple and straightforward. Simply answer the questions and get the results. Here we provide answers to some frequently asked questions about the app. If you do not find the answers to your questions here, or have comments and/or suggestions, please feel free to contact us via email at: <a href="mailto:liunian@indiana.edu">liunian@indiana.edu</a>
            </p>
          </div>
          <FAQ></FAQ>
          <Developers></Developers>
          <div class="text-center">
            <p>&copy; 2021</p>
          </div>
        </div>
      </div>
    );
  }  
}

export default Footer;
